import { paths } from "./paths";

function goToHome(history){
  if(history)
    history.push(paths.home)
}

export { goToHome }